import { ReactElement } from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { BrowserRouter } from 'react-router-dom';
import awsconfig from './amplifyconfiguration';
import UserProvider from './providers/UserProvider';
import { LocalStorageHandler } from './utils/LocalStorageHandler';
import { components } from './amplifyComponents';
import { formFields } from './amplifyFields';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReprocessProvider } from './providers/ReprocessProvider';
import AppRoutes from './routes/AppRoutes';
import { clearSingletonSessionsCache } from './hooks/useSingletonSessions';

Amplify.configure(awsconfig);

const storeToken = (user: any): void => {
  const accessToken = user?.signInUserSession?.accessToken;

  if (accessToken) {
    const { jwtToken } = accessToken;
    LocalStorageHandler.setUser(user.username);
    LocalStorageHandler.save('token', jwtToken);
  }
};

const queryClient = new QueryClient();

const App = (): ReactElement => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReprocessProvider>
        <Authenticator components={components} formFields={formFields} hideSignUp>
          {({ signOut, user }): ReactElement => {
            storeToken(user);
            return user ? (
              <UserProvider
                signOut={
                  signOut
                    ? () => {
                        clearSingletonSessionsCache();
                        signOut({ global: true });
                      }
                    : (): void => undefined
                }
              >
                {/* The v7_startTransition and v7_relativeSplatPath future flags
                    that used to be set here are the default in react-router 7,
                    and the `future` prop no longer accepts them. */}
                <BrowserRouter>
                  <AppRoutes />
                </BrowserRouter>
              </UserProvider>
            ) : (
              <div>No User</div>
            );
          }}
        </Authenticator>
      </ReprocessProvider>
    </QueryClientProvider>
  );
};

export default App;
